import { ReactNode } from 'react';
import { cn } from 'utils/cn';

type Props = {
    icon: ReactNode;
    active?: boolean;
    completed?: boolean;
    children?: ReactNode;
};

/** A step's dot and label. Elements marked `.label` are dimmed until the step is reached. */
export default function StepLabelStyled({ icon, active, completed, children }: Props) {
    const isReached = active || completed;
    return (
        <span className="flex items-center">
            <span className="flex shrink-0 pr-2">{icon}</span>
            <span
                className={cn(
                    '[&_.label]:text-fg w-full text-sm font-normal',
                    isReached ? 'text-fg [&_.label]:opacity-100' : 'text-fg-secondary [&_.label]:opacity-40'
                )}
            >
                {children}
            </span>
        </span>
    );
}
